import devEnv from './dev'
import prodEnv from './prod'
import simEnv from './sim'
import preEnv from './pre'
import { isSim, isPre, isOnline } from '@/utils/common/env'

let env = devEnv

if (isSim) {
  env = simEnv
} else if (isPre) {
  env = preEnv
} else if (isOnline) {
  env = prodEnv
}

const { BASE_API, LOGIN_URL, NODE_ENV } = env

export { BASE_API, LOGIN_URL, NODE_ENV }

export default env
